






import { Component, Vue, Prop } from 'vue-property-decorator';
import Loader from '@/components/loader/Loader.vue';

@Component({
  components: {
    Loader
  }
})
export default class InfiniteScroll extends Vue {
  @Prop({ required: true, default: false })
  loading!: boolean;

  @Prop({ required: true, default: false })
  hasNext!: boolean;

  async mounted() {
    window.onscroll = () => {
      const elem = document.documentElement;
      if (
        !this.loading &&
        elem.scrollTop + window.innerHeight > elem.offsetHeight - 300 &&
        this.hasNext
      ) {
        this.loadNextPage();
      }
    };
  }

  beforeDestroy() {
    window.onscroll = null;
  }

  loadNextPage() {
    this.$emit('load-more');
  }
}
